import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ViewportSizeProvider } from 'modules/layout/layoutContexts';
import * as serviceWorker from './serviceWorker';

import App from 'scenes/app/App';

import theme from './theme/theme';
import './index.scss';
import { ChakraProvider } from '@chakra-ui/provider';
// import mirage from './mirage';

// Redux
import { Provider } from 'react-redux';
import { store } from './app/store';

// Main App
const container = document.getElementById('app');
const root = createRoot(container);

// Main app
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ViewportSizeProvider>
        <ChakraProvider theme={theme}>
          <App />
        </ChakraProvider>
      </ViewportSizeProvider>
    </BrowserRouter>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
